import { api } from './client';

export type AffiliateTier = 'NONE' | 'BRONZE' | 'SILVER' | 'FOUNDERS_CIRCLE';

export interface TierInfo {
  current: AffiliateTier;
  label: string;
  badge: string;
  achievedAt: string | null;
  next: AffiliateTier | null;
  nextLabel: string | null;
  needs: null | {
    personalSpendUsdt?: number;
    directTeamVolumeUsdt?: number;
  };
  rates: {
    usdtPercent: number;
    aimlPercent: number;
    leadershipOverridePercent: number;
  };
}

export interface ReferralSummary {
  referralCode: string;
  referralUrl: string | null;
  tier: TierInfo;
  spend: {
    personalUsdt: number;
    directTeamVolumeUsdt: number;
  };
  kycStatus: 'NONE' | 'PENDING' | 'APPROVED' | 'REJECTED';
  stats: {
    totalClicks: number;
    totalSignups: number;
    qualifyingReferrals: number;
  };
  earnings: {
    totalCommissionEarnedUsdt: number;
    totalCommissionPaidUsdt: number;
    payableUsdt: number;
    totalLeadershipOverrideEarnedUsdt: number;
  };
  // Legacy fields (backward compatibility for any older code paths)
  referrerEligible: boolean;
  referrerEligibleAt: string | null;
  totalPurchasedUsdt: number;
  amountNeededForEligibility: number;
}

export interface Referee {
  id: string;
  email: string;
  walletAddress: string | null;
  joinedAt: string;
  kycStatus: 'NONE' | 'PENDING' | 'APPROVED' | 'REJECTED';
  totalPurchasedUsdt: number;
  qualifyingPurchases: number;
  youEarnedUsdt: number;
}

export const referralApi = {
  me: () => api<ReferralSummary>('/api/referral/me'),

  referees: () => api<{ referees: Referee[]; total: number }>('/api/referral/referees'),

  attribute: (data: { referralCode: string; txHash: string; walletAddress: string }) =>
    api<{ message: string }>('/api/referral/attribute', { method: 'POST', body: data }),

  click: (data: { referralCode: string; sessionId?: string }) =>
    api<void>('/api/referral/click', { method: 'POST', body: data }),
};
